module.exports = __webpack_public_path__ + "1f5d75fad89c4030abcfbed76a35afcd.pdf";